import { ReactNode } from "react";

import DrawerLayout from "client/common/components/stackables/DrawerLayout";
import { useDeletePaymentMethodMutation } from "client/payments/hooks";
import { useCurrentDrawer } from "client/common/hooks/stackables";

import styles from "../../styles/UpdatePaymentForm.module.less";

export type RemovePaymentDrawerProps = {
  id: number;
  paymentGroup: ReactNode;
  isCurrentlyPrimary: boolean;
  isImported: boolean;
  onSuccess: () => void;
};

const RemovePaymentDrawer = ({
  id,
  paymentGroup,
  isCurrentlyPrimary,
  isImported,
  onSuccess,
}: RemovePaymentDrawerProps) => {
  const { close } = useCurrentDrawer();
  const handleSuccess = () => {
    onSuccess();
    close();
  };
  const {
    mutate: deletePayment,
    isLoading: isDeleting,
    error: deletePaymentError,
  } = useDeletePaymentMethodMutation(id, { onSuccess: handleSuccess });

  return (
    <DrawerLayout>
      <DrawerLayout.Header title="Remove payment method" onClose={close} />
      <DrawerLayout.Form
        onSubmit={deletePayment}
        canSubmit={true}
        isLoading={isDeleting}
        submitText="Remove Method"
        error={deletePaymentError}
      >
        {paymentGroup}
        <DrawerLayout.Form.Group>
          <p className={styles.label}>This will permanently remove this payment method.</p>
        </DrawerLayout.Form.Group>
        {isImported && (
          <DrawerLayout.Form.Group>
            <p className={styles.label}>
              This is an imported payment method and cannot be re-added.
            </p>
          </DrawerLayout.Form.Group>
        )}
        {isCurrentlyPrimary && (
          <DrawerLayout.Form.Group>
            <p className={styles.label}>
              NOTE: Updating your primary payment method will not change the payment method of any
              Autoships.
            </p>
          </DrawerLayout.Form.Group>
        )}
      </DrawerLayout.Form>
    </DrawerLayout>
  );
};

export default RemovePaymentDrawer;
